import React from 'react'
import { object } from 'prop-types'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

const ListSubjects = ({ data }) => {
  let total = 0

  return (
    <Table>
      <thead>
        <tr>
          <th width="10%">Code</th>
          <th width="12%">Section</th>
          <th>Subject Description</th>
          <th width="4%" className="text-right">
            Units
          </th>
          <th width="4%" className="text-right">
            MT
          </th>
          <th width="4%" className="text-right">
            FT
          </th>
          <th width="4%" className="text-right">
            FG
          </th>
          <th width="4%" className="text-right">
            RE
          </th>
          <th width="8%">Remarks</th>
        </tr>
      </thead>
      <tbody>
        {data.get('subjects').map((item, k) => {
          if (item.get('action') === 3 || item.get('action') === 4) {
            return null
          }
          let remarks = ''
          if (item.get('fg')) {
            remarks = item.get('passed') ? 'Passed' : 'Failed'
          }
          total += item.get('units') - 0

          return (
            <tr key={k}>
              <td>{item.get('subject_code')}</td>
              <td>{item.get('section')}</td>
              <td>{item.get('subject_name')}</td>
              <td className="text-right">
                {acc.formatNumber(item.get('units'), 1)}
              </td>
              <td className="text-right">
                <strong>{item.get('mt')}</strong>
              </td>
              <td className="text-right">
                <strong>{item.get('ft')}</strong>
              </td>
              <td className="text-right">
                <strong>{item.get('fg')}</strong>
              </td>
              <td className="text-right">
                <strong>{item.get('re')}</strong>
              </td>
              <td>
                <small>
                  <em>{remarks}</em>
                </small>
              </td>
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        <tr>
          <th colSpan="3" className="text-right">
            Total Enrolled Units:<br />
            Total Earned Units:<br />
            GWA:
          </th>
          <th className="text-right">
            {acc.formatNumber(total, 1)}
            <br />
            {acc.formatNumber(data.getIn(['header', 'units_earned']), 1)}
            <br />
            {acc.formatNumber(data.getIn(['header', 'gwa']), 1)}
          </th>
          <th colSpan="5" />
        </tr>
      </tfoot>
    </Table>
  )
}

ListSubjects.propTypes = {
  data: object,
}

export default ListSubjects



// WEBPACK FOOTER //
// ./src/containers/Grades/list-subjects.js